import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
var MapGrid = function MapGrid(_ref) {
  var children = _ref.children;
  var ref = useRef();
  var _useState = useState({
      width: null,
      height: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    size = _useState2[0],
    setSize = _useState2[1];
  var resize = function resize() {
    if (ref && ref.current) {
      var width = ref.current.clientWidth;
      var height = ref.current.clientHeight;
      setSize({
        width: width,
        height: height
      });
    }
  };
  useEffect(function () {
    resize();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', resize, {
        passive: true
      }); //todo IE
    }
  }, []);
  var renderMaps = function renderMaps() {
    var availableWidth = size.width;
    var availableHeight = size.height;
    if (children.length && availableWidth && availableHeight) {
      var sizeRatio = availableWidth / availableHeight;
      var rows = 1,
        columns = 1;
      switch (children.length) {
        case 1:
          break;
        case 2:
          if (sizeRatio > 1) {
            columns = 2;
          } else {
            rows = 2;
          }
          break;
        case 3:
          if (sizeRatio > 2) {
            columns = 3;
          } else if (sizeRatio < 0.6666) {
            rows = 3;
          } else {
            columns = 2;
            rows = 2;
          }
          break;
        case 4:
          if (sizeRatio > 3) {
            columns = 4;
          } else if (sizeRatio < 0.5) {
            rows = 4;
          } else {
            columns = 2;
            rows = 2;
          }
          break;
        case 5:
        case 6:
          if (sizeRatio > 1) {
            columns = 3;
            rows = 2;
          } else {
            columns = 2;
            rows = 3;
          }
          break;
        case 7:
        case 8:
          if (sizeRatio > 2) {
            columns = 4;
            rows = 2;
          } else if (sizeRatio < 0.6666) {
            columns = 2;
            rows = 4;
          } else {
            columns = 3;
            rows = 3;
          }
          break;
        case 9:
          if (sizeRatio > 2.5) {
            columns = 5;
            rows = 2;
          } else if (sizeRatio < 0.5) {
            columns = 2;
            rows = 5;
          } else {
            columns = 3;
            rows = 3;
          }
          break;
        default:
          if (sizeRatio > 1) {
            columns = 4;
            rows = 3;
          } else {
            columns = 3;
            rows = 4;
          }
      }
      var width = +(100 / columns).toFixed(4) + '%';
      var height = +(100 / rows).toFixed(4) + '%';
      var style = {
        width: width,
        height: height
      };
      return children.map(function (map, index) {
        index++;
        var rowNo = Math.ceil(index / columns);
        var colNo = index % columns || columns;
        var wrapperClasses = classNames('ptr-map-grid-cell', 'row' + rowNo, 'col' + colNo, map.props.wrapperClasses);
        return /*#__PURE__*/_jsx("div", {
          className: wrapperClasses,
          style: style,
          children: map
        }, 'map-grid-cell-' + index);
      });
    } else {
      return null;
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: "ptr-map-grid",
    ref: ref,
    children: renderMaps()
  });
};
MapGrid.propTypes = {
  children: PropTypes.array
};
export default MapGrid;